import { o as n } from "./ContactType-9a05b343.mjs";
import { o as r } from "./AlternatePhoneType-940ae4fc.mjs";
const l = {
  Account: "ACCOUNT",
  Profile: "PROFILE"
}, p = {
  recipientFirstName: "",
  recipientLastName: "",
  phone: "",
  addrLineOne: "",
  addrLineTwo: "",
  contactNickname: "",
  postalCode: "",
  city: "",
  state: "",
  deliveryInstructions: "",
  contactType: n.Shipping,
  isDefault: !1
}, g = {
  firstName: "",
  lastName: "",
  email: ""
}, f = {
  mailingAddress: {
    contactType: n.Mailing
  },
  billingAddress: {
    contactType: n.Billing
  },
  taxAddress: {
    contactType: n.Billing
  },
  useAsBilling: !0,
  useAsMailing: !0,
  profileData: {
    firstName: "",
    lastName: "",
    titleSalutation: "",
    gender: "",
    maritalStatus: "",
    birthDate: "",
    citizenship: "",
    idNumber: "",
    email: "",
    phone: "",
    dialCode: "",
    alternativePhone: []
  }
}, m = {
  id: 0,
  type: r.Home,
  dialCode: "",
  number: ""
}, I = (a, t, i = l.Profile, e) => ({
  contactType: a,
  ownerType: i,
  addrLineOne: "",
  addrLineTwo: "",
  state: "",
  city: "",
  postalCode: "",
  contactId: "",
  accountNumber: parseInt(t ?? "0"),
  ownerId: e || t,
  isDefault: !1,
  province: "",
  provinceCode: "",
  district: ""
}), C = (a, t) => {
  const i = ApiConfigService.getTuples(), e = ConfigService.getConfigs();
  let o = "";
  if (typeof window < "u") {
    const s = {
      redirectUri: typeof t < "u" && (t == null ? void 0 : t.length) !== 0 ? t : `${e.NEXT_PUBLIC_WEB_BASE_PATH}`,
      headers: i,
      amwayLang: a
    };
    e.NEXT_PUBLIC_LOGIN_URL && (s.loginUrl = e.NEXT_PUBLIC_LOGIN_URL), o = btoa(JSON.stringify(s));
  }
  return {
    scope: "openid",
    state: o,
    countryIso: i["X-Amway-Country"],
    redirectUri: e.NEXT_PUBLIC_OIDC_URL ? `${e.NEXT_PUBLIC_OIDC_URL}` : ""
  };
}, u = (a) => new Promise((t, i) => {
  const e = new FileReader();
  e.readAsDataURL(a), e.onload = () => t(e.result), e.onerror = i;
});
export {
  m as A,
  g as C,
  f as P,
  p as S,
  I as a,
  u as c,
  C as g,
  l as o
};
//# sourceMappingURL=Utils-afbe19af.mjs.map
